import { useEffect } from 'react';
import AppRoutes from './routes/AppRoutes';

const App = () => {

  useEffect(() => {
    const saved = localStorage.getItem("fontScale");
    if (!saved) {
      let scale = 1;
      localStorage.setItem("fontScale", scale);
    }
    if (saved) {
      document.documentElement.style.setProperty("--font-scale", saved);
    }
  }, []);

  return (
    <div>
      <AppRoutes />
    </div>
  )
}

export default App
